import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('prd/purchase-order/drafts', { params })
  },

  async show (id) {
    return axios.get(`prd/purchase-order/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/purchase-order/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/purchase-order/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/purchase-order/drafts/${data.id}`, { data })
  }
}

export default DraftService
